import { Injectable } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { URLSearchParams, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { List } from 'immutable';
import { PropertyLookupSummary } from '../../models/property-lookup-summary';
import { PropertyLookupDetail } from '../../models/property-lookup-detail';
import { ResponseUtil } from '../../utils/response-util';
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';

@Injectable()
export class PropertyLookupHttpService {

  private propertySearchURL = `${this.environment.baseUrl}/api/lookup/properties`;
  private propertyDetailsURL = `${this.environment.baseUrl}/api/lookup/properties/details`;

  constructor(private http: AuthHttp,
              private environment: EnvironmentConfiguration) {
  }

  search(propertyName: string): Observable<List<PropertyLookupSummary>> {
    let params = new URLSearchParams();
    params.set('propertyName', propertyName);

    return this.http.get(this.propertySearchURL, { search: params })
      .map((res: Response) => res.json().map(object => new PropertyLookupSummary(object)))
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }

  getDetail(summaryRecord: PropertyLookupSummary): Observable<PropertyLookupDetail> {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers }); // Create a request option

    return this.http.post(`${this.propertyDetailsURL}`, JSON.stringify(summaryRecord), options)
      .map(response => new PropertyLookupDetail(response.json()))
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/lookup/property-lookup/property-lookup.http.service.ts